var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-open-app",
    class: {
      'is-show': _vm.showOpenAppBtn
    }
  }, [_vm._v("在APP打开")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };